import * as moment from 'moment';
import * as React from 'react';
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { signOut as signOutAction } from "../../actions/loginActions";
import {
  checkUncheck as checkUncheckAction, clearMailData as clearMailDataAction, refreshList as refreshListAction, selectMessage as selectMessageAction,
  setSortFieldAndOrder as setSortFieldAndOrderAction
} from "../../actions/mailActions";
import { addNotification as addNotificationAction, clearNotifications as clearNotificationsAction } from "../../actions/notificationsActions";
import { MailService } from '../../services/mail';
import Notification from '../common/Notification';
import UserSettings from '../settings/model/Settings';
import MessageListHeaderItem from './MessageListHeaderItem';
import Message from "./model/Message";

interface IMessageListHeaderProps {
  csrf: string;
  loginTime: number;
  messageList: Message[];
  settings: UserSettings;
  user: string;
  wsid: string;
  sortField: string;
  isDesc: boolean;
  addNotification: (notification: Notification) => any;
  clearMailData: () => any;
  clearNotifications: () => any;
  checkUncheck: (messages: Message[]) => any;
  refreshList: (messages: Message[]) => any;
  selectMessage: (messages: Message) => any;
  setSortFieldAndOrder: (sortField: string, isDesc: boolean) => any;
  signOut: () => any;
}

interface IMessageListHeaderState {
  selectAll: boolean;
}

export class MessageListHeader extends React.Component<IMessageListHeaderProps, IMessageListHeaderState> {

  public mailService: MailService;

  constructor(props: IMessageListHeaderProps) {
    super(props);
    this.state = { selectAll: false };
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.sortMessages = this.sortMessages.bind(this);
    this.mailService = new MailService(this.props.user, this.props.wsid, this.props.csrf);
  }

  public handleSelectAll() {
    if (this.props.messageList) {
      let anyUnselected = false;

      for (const m of this.props.messageList) {
        if (!m.selected) {
          anyUnselected = true;
          break;
        }
      }
      const selectedMessages = this.props.messageList.map((m) => {
        return { ...m, selected: anyUnselected ? true : !this.state.selectAll ? true : false };
      })
      this.props.checkUncheck(selectedMessages);
    }
    this.setState({ selectAll: !this.state.selectAll });
  }

  public async sortMessages(field: string) {
    try {
      const response = await this.mailService.list(0, 50, this.props.isDesc ? 'asc' : 'desc', field);

      if (!response.ok) {
        throw new Error(response.status.toString());
      }

      const msgList = await response.json();
      this.props.refreshList(msgList.messages);
      this.props.selectMessage(msgList.messages[0]); // select first message by default
      this.props.setSortFieldAndOrder(field, !this.props.isDesc);
    } catch (e) {
      if (e.message === '401') {
        if (moment().diff(this.props.loginTime, 'hours') < 12) {
          this.props.addNotification({ message: "Session Timeout", isError: true });
        }
        this.props.signOut();
        this.props.clearMailData();
      } else {
        this.props.addNotification({ messageKey: "L.Error.Retrieve", isError: true });
      }
    }
  }

  public render() {
    let { selectAll } = this.state;
    let anyUnselected = false;

    for (const m of this.props.messageList) {
      if (!m.selected) {
        anyUnselected = true;
        break;
      }
    }
    selectAll = this.props.messageList.length > 0 && !anyUnselected;
    return (
      <thead>
        <tr className="row">
          <th className="text col-sm-1 check" scope="col">
            <input id="selectAllCheckbox" type="checkbox" checked={selectAll} onChange={this.handleSelectAll} />
          </th>
          <MessageListHeaderItem colSize={2} field="from" translationId="L.From" defaultTranslationMessage="From" sortHandler={this.sortMessages} />
          <MessageListHeaderItem colSize={2} field="to" translationId="L.To" defaultTranslationMessage="To" sortHandler={this.sortMessages} />
          <MessageListHeaderItem colSize={5} field="subject" translationId="L.Subject" defaultTranslationMessage="Subject" sortHandler={this.sortMessages} />
          <MessageListHeaderItem colSize={2} field="date" translationId="L.Sent" defaultTranslationMessage="Sent" sortHandler={this.sortMessages} />
        </tr>
      </thead>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    csrf: state.authentication.csrf,
    isDesc: state.mail.isDesc,
    loginTime: state.authentication.loginTime,
    messageList: state.mail.messageList,
    settings: state.settings.settings,
    sortField: state.mail.sortField,
    user: state.authentication.user,
    wsid: state.authentication.wsid,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    addNotification: bindActionCreators(addNotificationAction, dispatch),
    clearMailData: bindActionCreators(clearMailDataAction, dispatch),
    clearNotifications: bindActionCreators(clearNotificationsAction, dispatch),
    checkUncheck: bindActionCreators(checkUncheckAction, dispatch),
    refreshList: bindActionCreators(refreshListAction, dispatch),
    selectMessage: bindActionCreators(selectMessageAction, dispatch),
    setSortFieldAndOrder: bindActionCreators(setSortFieldAndOrderAction, dispatch),
    signOut: bindActionCreators(signOutAction, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageListHeader);



// WEBPACK FOOTER //
// ./src/components/mail/MessageListHeader.tsx